import { faInr } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import Loader from '../../Components/loader';

function EmiTable({ amountToBePaid, bankId, mode, displayOrderNo , onBankCodeSelect , selectEmiCode,onProcessingFees}) {
  const [emiDetails, setEmiDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [processingFees, setProcessingFees] = useState('');
  


  useEffect(() => {
    const fetchEmiDetails = async () => {
      setLoading(true);
      setSelectedPlan('3');
      
      
      try {
        const response = await fetch('/pay/emiDetails/interest', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: amountToBePaid,
            emiBankId: bankId,
            mode: mode,
            orderNo: displayOrderNo,
          }),
        });

        if (!response.ok) {
          setEmiDetails({});
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        const firstPlanKey = Object.keys(data)[0]; 
        
        console.log('selectEmiCode'+selectEmiCode);
      
          setSelectedPlan(firstPlanKey);
          onProcessingFees(data[firstPlanKey].processingFees);
          setProcessingFees(data[firstPlanKey].processingFees);
          
          //onProcessingFees?.(data[firstPlanKey].processingFees);
          onBankCodeSelect(data[firstPlanKey].bank_emi_code);
        
        
        setEmiDetails(data);
      } catch (error) {
      	 setEmiDetails({});
         onProcessingFees('');
        console.error('Error fetching EMI details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmiDetails();
  }, [amountToBePaid, bankId, mode, displayOrderNo]);

   const handlePlanSelect = (plan) => {
    setSelectedPlan(plan.code);
    onBankCodeSelect(plan.code); // Pass selected EMI code to parent
    onProcessingFees(plan.processingFee || ''); // Pass fee info
  };

  const renderEmiDetails = () => {
    if (loading) {
      return <Loader show={true} textToShow="Please wait while your transaction is being processed" />;
    }
    
    const emiArray = Object.entries(emiDetails);

    return emiArray.map(([key, plan]) => (
      <div key={key}>
        <ul className='emi-table-head'>
          <li>
            <input
              type="radio"
              name="emiPlan"
              value={key}
              checked={selectedPlan === key}
               onChange={() => {
                setSelectedPlan(key);
                onBankCodeSelect(plan.bank_emi_code); 
                onProcessingFees(plan.processingFees); 
            //    handlePlanSelect(plan);
                
              }}
            />
           
          </li>
          <li> <strong>{plan.tenure}</strong></li>
          <li>
            <strong>{plan.interest}%</strong>
          </li>
          <li>
            <strong>
              <FontAwesomeIcon icon={faInr} /> {plan.monthly_inst.toFixed(2)}
            </strong>
          </li>
          <li>
            <strong>
              <FontAwesomeIcon icon={faInr} />
              {plan.bank_inst.toFixed(2)}
            </strong>
          </li>
          <li>
            <strong>
              <FontAwesomeIcon icon={faInr} />
              {plan.total_inst.toFixed(2)}
            </strong>
          </li>

          
        </ul>
      </div>
    ));
  };

  return (
    <div className='emi-table-view'>
      {loading ? (
        <Loader show={true} textToShow="" />
      ) : (
        <>
          <div className='emi-table-heading'>
            <h3>EMI Details</h3>
            <ul className='emi-table-head'>
              <li><span>Select</span></li>
              <li><span>Tenure</span></li>
              <li><span>Interest Rate</span></li>
              <li><span>Monthly EMI</span></li>
              <li><span>Interest Paid</span></li>
              <li><span>Amount Payable</span></li>
              
            </ul>
          </div>
          {renderEmiDetails()}
        </>
      )}
    </div>
  );
  
}

export default EmiTable;

